import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule } from '@ecm/router';

import { ContractV7Offer } from '../../../../business/api/dashboardV7/contract/contractV7Offer';
import { SubItemComponent } from '../sub-item.component';

@Component({
    selector: 'gauge-sub-item',
    templateUrl: 'gauge-sub-item.html',
    styleUrls: ['../sub-item.css', 'gauge-sub-item.css'],
    standalone: true,
    imports: [EcmMaterialModule, NgTemplateOutlet, NgClass, AsyncPipe, EcmRouterModule],
})
export class GaugeSubItemComponent extends SubItemComponent implements OnInit {
    @Input()
    public offer!: ContractV7Offer;
}
